import { Router } from '@angular/router';
import { ALL_ASSESSMENTS_PAGE_SIZE, colDefs, defaultColDef } from './all-assessment-table.config';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AllAssessmentStore } from '@features/assessments/stores/all-assessments.store';
import { AgGridAngular } from 'ag-grid-angular';
import { GridReadyEvent, RowModelType, type RowClickedEvent } from 'ag-grid-community';
import { customTheme } from 'src/styles/grid-table/grid-table-theme';

@Component({
  selector: 'app-all-assessments-table',
  imports: [AgGridAngular],
  template: `
    <ag-grid-angular
      style="width: 100%; height: 100%"
      [columnDefs]="colDefs"
      [pagination]="true"
      [paginationPageSize]="pageSize"
      [paginationPageSizeSelector]="false"
      [defaultColDef]="defaultColDef"
      [tooltipShowDelay]="500"
      [tooltipInteraction]="true"
      tooltipShowMode="whenTruncated"
      [rowModelType]="rowModelType"
      [maxBlocksInCache]="maxBlocksInCache"
      [cacheBlockSize]="pageSize"
      (rowClicked)="onRowClicked($event)"
      [theme]="theme"
      (gridReady)="onGridReady($event)"
    />
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllAssessmentsTableComponent {
  readonly router = inject(Router);
  readonly store = inject(AllAssessmentStore);

  defaultColDef = defaultColDef;
  colDefs = colDefs;

  rowModelType: RowModelType = 'infinite';
  maxBlocksInCache = 5;
  pageSize = ALL_ASSESSMENTS_PAGE_SIZE;

  theme = customTheme;

  onGridReady(params: GridReadyEvent) {
    this.store.initGridApi(params.api);
  }

  onRowClicked(event: RowClickedEvent) {
    if (event.data) {
      this.router.navigate(['/assessments/detail', event.data.id]);
    }
  }
}
